import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { differenceInBusinessDays } from 'date-fns';
import {
  FormControl,
  Button
} from "@material-ui/core";
import Spacer from "../../../components/Spacer";
import MainContainer from "../../../components/MainContainer";
import { headerDataMission } from "../../../data/modules/mission-header";
import PlanningMissionService from "../../../services/PlanningMissionService";
import FonctionService from "../../../services/FonctionService";
import MissionService from "../../../services/MissionService";
import Alert from "@material-ui/lab/Alert";
import Message from "../../tools/Message";
import { AntTab, AntTabs } from "../../../components/ant-tab";
import { Typography, Box } from "@material-ui/core";
import PropTypes from "prop-types";
import PlanningMissionDetailsAdd from "./PlanningMissionDetailsAdd";
import { useNavigate } from "react-router-dom";
import {Autocomplete, Checkbox, RadioGroup, Radio, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@mui/material';
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import { Chip } from "@material-ui/core";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import { Stack } from '@mui/material';
import ts from "typescript";
import { LoadingButton } from '@mui/lab';
import LocalisationMisService from "../../../services/LocalisationMisService";
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Slide from '@mui/material/Slide';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import PlanningService from "../../../services/PlanningService";

function TabPanel(props) {
  const { children, value, index } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});


const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "row",
    elevation: 0,
  },
  form: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: 2,
  },
  labelPosition: {
    float: "left",
  },
  labelPosition1: {
    float: "right",
  },
  text: {
    width: 370,
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  root: {
    width: "100%"
  }
}));

const noteStyle = {
  backgroundColor: '#d4edda', 
  color: '#155724',            
  borderRadius: '5px',
  border: '1px solid #c3e6cb',
  maxWidth: '100%',
  textAlign: 'center',
  margin: '0' 
};

const noteStyleerreur = {
  backgroundColor: '#e43a06',           
  borderRadius: '5px',
  border: '1px solid #c3e6cb',
  width: '100%',         
  textAlign: 'center',
  padding: '10px 0',    
  boxSizing: 'border-box' 
};

const noteStyleWarning = {
  backgroundColor: '#fff3cd', 
  color: '#856404',            
  borderRadius: '5px',
  border: '1px solid #ffeeba',
  width: '100%',         
  textAlign: 'center',
  padding: '10px 0',    
  boxSizing: 'border-box' 
};

function PlanningMissionAdd(props) {
  const [direction, setDirection] = useState([]);
  const [service, setService] = useState([]);
  const [intervenant, setIntervenant] = useState([]);
  const [raison,setRaison]=useState(null);

  const [pdirection, setPdirection] = useState([]);
  const [pservice, setPservice] = useState([]);
  const [pintervenant, setPintervenant] = useState([]);
  const [pfonction, setPfonction] = useState([]);
  const [loading, setLoading] = useState(false);
  
  const [direction_id, setDirection_id] = useState(0);
  const [service_id, setService_id] = useState(0);

  const [pdirection_id, setPdirection_id] = useState(0);
  const [pservice_id, setPservice_id] = useState(0);
  const [pfonction_id, setPfonction_id] = useState([]);

  const [isValidMission_title, setIsValidMission_title] = useState(false);
  const [isValidCategory_mission_id, setIsValidCategory_mission_id] = useState(false);
  const [category, setCategory] = useState([]);
  const [isValidTransport_type, setIsValidTransport_type] = useState(false);
  const navigate = useNavigate();
  const classes = useStyles();
  const pathname = window.location.pathname;
  const segments = pathname.split('/');
  const distinctpage = segments[3];
  const missionId = segments[segments.length - 1];
  const [typeintervenants, setTypeintervenant] = useState("uni");
  const [participant, setParticipants] = useState([]);
  const [tags, setTags] = useState([]);
  const [partnership, setPartnership] = useState('');
  const [intervenants, setIntervenants] = useState('');
  const [tagsintervenant, setTagsintervenant] = useState([]);
  const [transport, setTransport] = useState([]);
  const [region, setRegion] = useState([]);
  const [district, setDistrict] = useState([]);
  const [commune, setCommune] = useState([]);
  const [isalert, setIsalert] = useState(0);
  const [missionReportType, setMissionReportType] = useState('mission'); 
  const [affichelist, setAffichelist] = useState(false);
  const [planninglist, setPlanninglist] = useState([]);
  const [listnotRapport, setListnotRapport] = useState([]);
  const [affichelistwithoutrapport, setAffichelistwithoutrapport] = useState(false);
  const [openBackdrop, setOpenBackdrop] = useState(false);
  
  // États pour la dérogation
  const [showDerogationDialog, setShowDerogationDialog] = useState(false);
  const [derogationReason, setDerogationReason] = useState("");
  const [isSubmittingDerogation, setIsSubmittingDerogation] = useState(false);
  const [pendingFormForDerogation, setPendingFormForDerogation] = useState(null);

  // ⬇️ NOUVEAU : Ref pour bloquer la navigation pendant l'affichage des dialogues
  const blockNavigationRef = React.useRef(false);

  const [sections, setSections] = useState([
      {
        lieu: "",
        direction_dest: null,
        date_depart: "",
        date_retour: "",
        directions: [],
        services: [],
        missionnaires: [],
        region: null,
        district: [],
        commune: [],
        planning_destination: null
      },
    ]);
  
  const addSection = () => {
      setSections([
        ...sections,
        {
          lieu: "",
          direction_dest: null,
          date_depart: "",
          date_retour: "",
          directions: [],
          services: [],
          missionnaires: [],
          region: null,
          district: [],
          commune: [],
          planning_destination: null
        },
      ]);
  };
  
  const removeSection = (index) => {
      const newSections = sections.filter((_, i) => i !== index);
      setSections(newSections);
  };

  const handleClosealert = () => {
    setAffichelist(false);
  };

  const handleReportTypeChange = (type) => {
    setMissionReportType(type);
  };

  function handlesuivant(event) {
    // ⬇️ Empêche tout comportement par défaut (submit de formulaire, etc.)
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (Array.isArray(sections) && sections.length === 0) {
      setMessage({
        ...message,
        open: true,
        color: 'red',
        messageInfo: "Veuillez cliquer sur le bouton AJOUTER UNE NOUVELLE DESTINATION puis renseigner les détails de la destination ainsi que les informations sur les missionnaires"
      });
      return;
    }

    const updatedForm = {
      ...form,
      section: sections
    };

    setForm(updatedForm);
    setOpenBackdrop(true);

    PlanningMissionService.getValidatedMissionsWithoutReport(sections)
      .then((result) => {
        if (result.status) {
          const list = result.data;
          if (list.length > 0) {
         
            // ⬇️ On bloque toute navigation, on affiche seulement le dialogue
            blockNavigationRef.current = true;
            setListnotRapport(list);
            setPendingFormForDerogation(updatedForm);
            setAffichelistwithoutrapport(true);
            setOpenBackdrop(false);
            // ⚠️ IMPORTANT : On ne fait RIEN d'autre ici, pas de submitPlanning
          } else {
            // Aucune mission sans rapport -> soumission directe
            submitPlanning(updatedForm);
          }
        } else {
          setOpenBackdrop(false);
          setMessage({
            ...message,
            open: true,
            color: 'red',
            messageInfo: "Erreur lors de la validation des missions"
          });
        }
      })
      .catch((err) => {
        setOpenBackdrop(false);
        setMessage({
          ...message,
          open: true,
          color: 'red',
          messageInfo: 'Erreur serveur'
        });
        console.error(err);
      });
  }
  
  // Fonction pour soumettre la planification
  const submitPlanning = (updatedForm) => {
    // ⬇️ Sécurité : si on est en mode dialogue de dérogation, ne pas naviguer
    if (blockNavigationRef.current) {
      console.log("submitPlanning bloqué : dialogue de dérogation actif");
      return;
    }

    PlanningMissionService.updateMissionPlanning(updatedForm)
      .then((result) => {
        if (result.status) {
          setMessage({
            ...message,
            open: true,
            color: 'green',
            messageInfo: result.message
          });
          setOpenBackdrop(false);
          navigate('/mission/planning_mission/detail/' + missionId);
        } else {
          setMessage({
            ...message,
            open: true,
            color: 'red',
            messageInfo: result.message
          });
          setOpenBackdrop(false);
        }
      })
      .catch((err) => {
        setOpenBackdrop(false);
        setMessage({
          ...message,
          open: true,
          color: 'red',
          messageInfo: 'Erreur'
        });
        console.error(err);
      });
  };

  // Fonction pour soumettre une dérogation pour toutes les missions sans rapport
  const submitDerogation = () => {
    if (!derogationReason.trim()) {
      setMessage({
        ...message,
        open: true,
        color: 'red',
        messageInfo: "Veuillez fournir une raison pour la dérogation"
      });
      return;
    }


    setIsSubmittingDerogation(true);
    
    const baseForm = pendingFormForDerogation || form;
    const updatedForm = {
      ...baseForm,
      section: sections,
      typerapport: missionReportType,
      derogation_reason: derogationReason,
      missions_without_report_ids: listnotRapport.map(mission => mission.mission_planning_id)
    };

    console.log("updatedForm avec dérogation", updatedForm);
    
    PlanningMissionService.updateMissionPlanningWithDerogation(updatedForm)
      .then((result) => {
        if (result.status) {
          // ⬇️ On débloque la navigation seulement à ce moment
          blockNavigationRef.current = false;
          setMessage({
            ...message,
            open: true,
            color: 'green',
            messageInfo: "Dérogation soumise avec succès et mission mise à jour. Un email a été envoyé à votre supérieur hiérarchique."
          });
          setShowDerogationDialog(false);
          setDerogationReason("");
          setOpenBackdrop(false);
          PlanningMissionService.updateMissionPlanning(updatedForm)
              .then((result) => {
                if (result.status) {
                  setMessage({
                    ...message,
                    open: true,
                    color: 'green',
                    messageInfo: result.message
                  });
                  setOpenBackdrop(false);
                  navigate('/mission/planning_mission/detail/' + missionId);
                } else {
                  setMessage({
                    ...message,
                    open: true,
                    color: 'red',
                    messageInfo: result.message
                  });
                  setOpenBackdrop(false);
                }
              })
              .catch((err) => {
                setOpenBackdrop(false);
                setMessage({
                  ...message,
                  open: true,
                  color: 'red',
                  messageInfo: 'Erreur'
                });
                console.error(err);
              });

        } else {
          setMessage({
            ...message,
            open: true,
            color: 'red',
            messageInfo: result.message || "Erreur lors de la soumission de la dérogation"
          });
          setIsSubmittingDerogation(false);
          setOpenBackdrop(false);
        }
      })
      .catch((err) => {
        setMessage({
          ...message,
          open: true,
          color: 'red',
          messageInfo: "Erreur serveur lors de la soumission de la dérogation"
        });
        setIsSubmittingDerogation(false);
        setOpenBackdrop(false);
        console.error(err);
      });
  };
  
  const handleSectionChange = (index, field, value) => {
      const newSections = [...sections];
      newSections[index][field] = value;
      setSections(newSections);

      if (field==="date_retour") {
          if (value < newSections[index]["date_depart"]) {
            setMessage({
              ...message,
              open: true,
              color: 'red',
              messageInfo: "La date de départ doit être antérieure à la date de retour."
            });
          }

          const businessDaysDiff = differenceInBusinessDays(new Date(newSections[index]["date_retour"]), new Date(value));
          if (businessDaysDiff > 22) {
            setMessage({
              ...message,
              open: true,
              color: 'red',
              messageInfo: "La durée entre la date de départ et la date de retour ne doit pas dépasser un mois (jours ouvrés)."
            });
          }
      }
      if (field==="directions") { 
        setDirection_id(value);
        const directionIds = value.map(item => parseInt(item.direction_id, 10));
        PlanningMissionService.getService(directionIds).then((result) => {
          if (result && result.data) {
            setService(result.data);
          }
        });
      }
      if (field==="services") {
        const serviceIds = Array.isArray(value) ? value.map(item => parseInt(item.service_id, 10)) : [];
        const directionIds = Array.isArray(direction_id) ? direction_id.map(item => parseInt(item.direction_id, 10)) : [];
        PlanningMissionService.getIntervenant(directionIds,serviceIds).then((result) => {
          if (result && result.data) {
            setIntervenant(result.data);
          }
        });
      }
      if (field==="region") {
           if (value && value.id_region) {
              LocalisationMisService.getDistrictByRegion(value.id_region).then((result) => {
                  if (result && result.data) {
                      setDistrict(result.data);
                  }
              });
          }
      }
      if (field==="district") {
        const numericIdsArray = value.map(item => parseInt(item.id_district));
          LocalisationMisService.getCommune(numericIdsArray).then((result) => {
            if (result && result.data) {
                setCommune(result.data);
            }
          });
      }
  };
    
  const [form, setForm] = useState({
    mission_planning_id:"",
    category_mission_id: {},
    mission_title: "",
    transport_type: "",
    user_id:[],
    participant:[],
    observation:"",
    partnership:[],
    intervenants:[],
    list_user:[],
    grouppar:[],
    lieu:'',
    direction_dest:{},
    date_depart:"",
    date_retour:""
  });
  
  const options = [
    { label: 'Direction', value: 'direction' },
    { label: 'Service', value: 'service' },
    { label: 'Fonction', value: 'fonction' }
  ];
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;

  const [selectedOptions, setSelectedOptions] = useState([]);
  const [loadingenr, setLoadingenr] = useState(false);

  const handleOptionChange = (event, newValue) => {
    setForm({ ...form, grouppar: newValue });
    setSelectedOptions(newValue);
  };

  const [message, setMessage] = React.useState({
    open: false,
    color: "green",
    messageInfo: "",
  });
  const { open, color, messageInfo } = message;

  const selectAllOption = {
    user_id: '0',
    first_name: 'Sélectionner',
    last_name: 'tout'
  };

  const isOptionEqualToValueDirection = (option, value) => {
    return option.direction_id === value?.direction_id;
  };

  const isOptionEqualToValueService = (option, value) => {
    return option.service_id === value?.service_id;
  };

  const isOptionEqualToValueIntervenant = (option, value) => {
    return option.user_id === value?.user_id;
  };

  const isOptionEqualToValueRegion = (option, value) => {
    return option.id_region === value?.id_region;
  };

  const isOptionEqualToValueDistrict = (option, value) => {
    return option.id_district === value?.id_district;
  };

  const isOptionEqualToValueCommune = (option, value) => {
    return option.id_commune === value?.id_commune;
  };

  const isOptionEqualToValueTransport = (option, value) => {
    return option.transport_id === value?.transport_id;
  };

  const isOptionEqualToValueCategory = (option, value) => {
    return option.category_mission_id === value?.category_mission_id;
  };

  const isOptionEqualToValueFonction = (option, value) => {
    return option.function_id === value?.function_id;
  };

  const isOptionEqualToValueParticipant = (option, value) => {
    return option.user_id === value?.user_id;
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' && partnership.trim() !== '') {
      event.preventDefault();
      
      const trimmedPartnership = partnership.trim();
    
      if (!tags.includes(trimmedPartnership)) {
        const updatedTags = [...tags, trimmedPartnership];
        setTags(updatedTags);
        
        setForm(prevForm => ({ ...prevForm, partnership: updatedTags }));
      }
      setPartnership('');
    }
  };
  
  const handleChangepartenachip = (event) => {
    setPartnership(event.target.value);
  };

  const handleKeyDownintervenantsautre = (event) => {
    if (event.key === 'Enter' && intervenants.trim() !== '') {
      event.preventDefault();
      
      const trimmedPartnership = intervenants.trim();
    
      if (!tagsintervenant.includes(trimmedPartnership)) {
        const updatedTags = [...tagsintervenant, trimmedPartnership];
        setTagsintervenant(updatedTags);
        setForm(prevForm => ({ ...prevForm, intervenants: updatedTags }));
      }
      setIntervenants('');
    }
  };
  
  const handleChangeintervenantsautre = (event) => {
    setIntervenants(event.target.value);
  }

  const handleClosealertrapport = () => {
    setAffichelistwithoutrapport(false);
    // ⬇️ Si l'utilisateur ferme sans demander de dérogation, on débloque
    blockNavigationRef.current = false;
  };

  const handleOpenDerogation = () => {
    setShowDerogationDialog(true);
    setAffichelistwithoutrapport(false);
  };

  const handleCloseDerogation = () => {
    setShowDerogationDialog(false);
    setDerogationReason("");
    // ⬇️ On débloque la navigation
    blockNavigationRef.current = false;
  };
  
  const handleDeleteintervenant = (tagToDelete) => {
    const updatedTags = tagsintervenant.filter(tag => tag !== tagToDelete);
  
    setTagsintervenant(updatedTags);
    setForm(prevForm => ({ ...prevForm, intervenants: updatedTags }));
  };

  const handleDelete = (tagToDelete) => {
    const updatedTags = tags.filter(tag => tag !== tagToDelete);
  
    setTags(updatedTags);
    setForm(prevForm => ({ ...prevForm, partnership: updatedTags }));
  };

  function handleChangeDirection(event, value){
    const directionIds = value.map(item => parseInt(item.direction_id, 10));
    setDirection_id(value);
    PlanningMissionService.getService(directionIds).then((result) => {
      if (result && result.data) {
        setService(result.data);
      }
    });
  }

  function handleChangepDirection(event, value){
    const directionIds = value.map(item => parseInt(item.direction_id, 10));
    setPdirection_id(value);
    PlanningMissionService.getService(directionIds).then((result) => {
      if (result && result.data) {
        setPservice(result.data);
      }
    });
  }

  function handleChangeService(event, value){
    setService_id(value);
  }

  function handleChangepService(event, value){
    setPservice_id(value);
  }
  
  function handleChangepfonction(event, value){
    const tb = value.map(item => item.function_id);
    setPfonction_id(tb);
  }
  
  function handleChangeIntervenants(event, value){
    setForm({ ...form, user_id: value });
  }

  function handleChangelistuser(event, value){
    if (value.some(option => option.user_id === 'select_all')) {
      setForm({ ...form, list_user: participant });
    } else {
      setForm({ ...form, list_user: value });
    }
  }

  const MISSION_PLANNING_TEMP = JSON.parse(
    localStorage.getItem("MISSION_PLANNING_TEMP")
  );

  useEffect(() => {
    const serviceIds = Array.isArray(service_id) ? service_id.map(item => parseInt(item.service_id, 10)) : [];
    const directionIds = Array.isArray(direction_id) ? direction_id.map(item => parseInt(item.direction_id, 10)) : [];
    PlanningMissionService.getIntervenant(directionIds,serviceIds).then((result) => {
      if (result && result.data) {
        setIntervenant(result.data);
      }
    });
  }, [direction_id, service_id]);

  useEffect(() => { 
    const serviceIds = Array.isArray(pservice_id) ? pservice_id.map(item => parseInt(item.service_id, 10)) : [];
    const directionIds = Array.isArray(pdirection_id) ? pdirection_id.map(item => parseInt(item.direction_id, 10)) : [];
    MissionService.participants(directionIds,serviceIds,pfonction_id).then((result) => {
        if (result && result.data) {
          setParticipants(result.data);
        }
      });
  }, [pdirection_id, pservice_id, pfonction_id]);
  
  useEffect(() => { 
    const serviceIds = Array.isArray(pservice_id) ? pservice_id.map(item => parseInt(item.service_id, 10)) : [];
    const directionIds = Array.isArray(pdirection_id) ? pdirection_id.map(item => parseInt(item.direction_id, 10)) : [];
    FonctionService.getfonctionBydirserv(directionIds,serviceIds).then((result) => {
      if (result && result.data) {
          setPfonction(result.data);
      }
    });
  }, [pdirection_id, pservice_id]);

  useEffect(() => {
    setLoading(true);
    PlanningMissionService.getCategory().then((result) => {
      if (result && result.data) {
        setCategory(result.data);
        setLoading(false);
      }
    });
  
    PlanningMissionService.getDirection().then((result) => {
      if (result && result.data) {
        setDirection(result.data);
      }
    });

    PlanningMissionService.getDirection().then((result) => {
      if (result && result.data) {
        setPdirection(result.data);
      }
    });

    PlanningMissionService.transport().then((result) => {
      if (result && result.data) {
        setTransport(result.data);
      }
    });

    FonctionService.getfonction().then((result) => {
      if (result && result.data) {
        setPfonction(result.data);
      }
    });

    PlanningMissionService.planningactive().then((result) => {
      setIsalert(parseInt(result.data,10));
    });

     PlanningService.getraisonplanning(missionId).then((result) => {
      setRaison(result.data);
    });

    LocalisationMisService.getRegions().then((result) => {
      if (result && result.data) {
        setRegion(result.data);
      }
    });

    if (missionId !== "add") {
      PlanningMissionService.getdetails(missionId).then((result) => {
        if(result.status && result.data.length > 0){
          PlanningMissionService.getDirection().then((res) => {
            if (res.status) {
              const defaultTransportValues = result.data[0].transport.map(item => item.transport_id.toString());
              setForm({
                mission_planning_id: result.data[0].mission_planning_id,
                category_mission_id: result.data[0].categorie,
                mission_title: result.data[0].mission_title,
                transport_type: defaultTransportValues,
                user_id: result.data[0].users || [],
                observation: result.data[0].observation,
                partnership: result.data[0].partnership ? JSON.parse(result.data[0].partnership) : [],
                intervenants: result.data[0].intervenant ? JSON.parse(result.data[0].intervenant) : [],
                list_user: [],
                grouppar: [],
                lieu: result.data[0].lieu || "",
                direction_dest: {},
                date_depart: result.data[0].date_depart || "",
                date_retour: result.data[0].date_retour || ""
              });
              setMissionReportType(result?.data[0]?.typerapportmission ?? "mission");
            }
            
            if (result.data && result.data.length > 0) {
              const destinations = result.data[0].destination;

              const getUpdatedSections = async () => {
                const directionsResult = await PlanningMissionService.getDirection();

                return Promise.all(
                  destinations.map(async (item) => {
                    let directionValue = null;

                    if (directionsResult && directionsResult.data) {
                      const filtered = directionsResult.data.filter(tr => tr.direction_id === item.direction_id);
                      directionValue = filtered.length > 0 ? filtered[0] : null;
                    }

                    return {
                      lieu: item.lieu || "",
                      direction_dest: directionValue,
                      date_depart: item.date_begin ? item.date_begin.split(" ")[0] : "",
                      date_retour: item.date_end ? item.date_end.split(" ")[0] : "",
                      directions: item.uniquedirection || [],
                      services: item.uniqueservice || [],
                      missionnaires: item.missionary || [],
                      destination_id: item.planning_destination,
                      region: item.region ? JSON.parse(item.region) : null,
                      district: item.district ? JSON.parse(item.district) : [],
                      commune: item.commune ? JSON.parse(item.commune) : [],
                      planning_destination: item.planning_destination
                    };
                  })
                );
              };
              getUpdatedSections()
                .then(updatedSections => {
                  const validatedSections = updatedSections.map(section => ({
                    lieu: section.lieu || "",
                    direction_dest: section.direction_dest || null,
                    date_depart: section.date_depart || "",
                    date_retour: section.date_retour || "",
                    directions: section.directions || [],
                    services: section.services || [],
                    missionnaires: section.missionnaires || [],
                    region: section.region || {},
                    district: section.district || [],
                    commune: section.commune || [],
                    planning_destination: section.planning_destination || null
                  }));
                  setSections(validatedSections);
                })
                .catch(error => {
                  console.error("Error fetching updated sections:", error);
                });

              setTags(result.data[0].partnership ? JSON.parse(result.data[0].partnership) : []);
              setTagsintervenant(result.data[0].intervenant ? JSON.parse(result.data[0].intervenant) : []);
              setTypeintervenant(result.data[0].categtype || "uni");
            }
          });
        }
      }).catch((err) => {
        console.error(err);
      });
    }
  }, [missionId]);

  function handleclickplanning() {
    const isSectionIncomplete = sections.some(section =>
      !section.direction_dest ||                
      !section.date_depart ||                      
      !section.date_retour ||                  
      !Array.isArray(section.directions) || section.directions.length === 0 ||
      !Array.isArray(section.services) || section.services.length === 0 ||
      !Array.isArray(section.missionnaires) || section.missionnaires.length === 0 ||
      !section.region || Object.keys(section.region).length === 0 ||
      !Array.isArray(section.district) || section.district.length === 0
    );
    if (Array.isArray(sections) && sections.length === 0) {
        setMessage({ ...message, open: true, color: 'red', messageInfo: "Veuillez cliquer sur le bouton AJOUTER UNE NOUVELLE DESTINATION puis renseigner les détails de la destination ainsi que les informations sur les missionnaires "});
    }
    else if(isSectionIncomplete) {
      setMessage({
        ...message,
        open: true,
        color: 'red',
        messageInfo: "Veuillez remplir tous les champs requis pour chaque section avant de continuer."
      });
    }
    else if(Array.isArray(form.transport_type) && form.transport_type.length === 0) {
       setMessage({ ...message, open: true, color: 'red', messageInfo: "Veuillez ajouter un moyen de transport"});
    }
    else {
      const updatedForm = { ...form, section: sections };
      setForm(updatedForm);
      setLoadingenr(true);
      if (updatedForm.mission_planning_id !== "") {
        PlanningMissionService.updateMissionPlanning(updatedForm)
          .then((result) => {
            if (result.status) {
               PlanningMissionService.updatevalidationplanning(updatedForm.mission_planning_id).then((result) => {
                    if (result) {
                           setMessage({ ...message, open: true, color: 'green', messageInfo: result.message });
                           setLoadingenr(false);
                           navigate("/mission/planning_mission");
                    }
                });
            } else {
              setLoadingenr(false);
              setMessage({ ...message, open: true, color: 'red', messageInfo: result.message });
            }
          })
          .catch((err) => {
            setLoadingenr(false);
            setMessage({ ...message, open: true, color: 'red', messageInfo: 'erreur' });
          });
      }
    }
  }

  function handleClick() {
    const isSectionIncomplete = sections.some(section => 
      !section.direction_dest ||                
      !section.date_depart ||                      
      !section.date_retour ||                  
      !Array.isArray(section.directions) || section.directions.length === 0 ||
      !Array.isArray(section.services) || section.services.length === 0 ||
      !Array.isArray(section.missionnaires) || section.missionnaires.length === 0 ||
      !section.region || Object.keys(section.region).length === 0 || 
      !Array.isArray(section.district) || section.district.length === 0
    );
    if (Array.isArray(sections) && sections.length === 0) {
        setMessage({ ...message, open: true, color: 'red', messageInfo: "Veuillez cliquer sur le bouton AJOUTER UNE NOUVELLE DESTINATION puis renseigner les détails de la destination ainsi que les informations sur les missionnaires "});
    } 
    else if(isSectionIncomplete) {
      setMessage({ 
        ...message, 
        open: true, 
        color: 'red', 
        messageInfo: "Veuillez remplir tous les champs requis pour chaque section avant de continuer." 
      });
    }
    else if(Array.isArray(form.transport_type) && form.transport_type.length === 0) {
       setMessage({ ...message, open: true, color: 'red', messageInfo: "Veuillez ajouter un moyen de transport"});
    }
    else {
      const updatedForm = { ...form, section: sections, typerapport: missionReportType };
      setForm(updatedForm);
      setLoadingenr(true);
      
      if (updatedForm.mission_planning_id !== "") {
        PlanningMissionService.updateMissionPlanning(updatedForm)
          .then((result) => {
            if (result.status) {
              setMessage({ ...message, open: true, color: 'green', messageInfo: result.message });
              setLoadingenr(false);
              navigate("/mission/planning_mission");
            } else {
              setLoadingenr(false);
              setMessage({ ...message, open: true, color: 'red', messageInfo: result.message });
            }
          })
          .catch((err) => {
            setLoadingenr(false);
            setMessage({ ...message, open: true, color: 'red', messageInfo: 'erreur' });
          });
      } else {
        PlanningMissionService.saveMissionPlanning(updatedForm)
          .then((result) => {
            if (result.status) {
              setLoadingenr(false);
              setMessage({ ...message, open: true, color: 'green', messageInfo: result.message });
              navigate("/mission/planning_mission");
            } else {
              setLoadingenr(false);
              setMessage({ ...message, open: true, color: 'red', messageInfo: result.message });
            }
          })
          .catch((err) => {
            setLoadingenr(false);
            setMessage({ ...message, open: true, color: 'red', messageInfo: 'erreur' });
          });
      }
    }
  }

  function handleChange(event) {
    const { name, value } = event.target;
    setForm({ ...form, [name]: value });
  }

  function handleCloseMessage() {
    setMessage({ ...message, open: false });
  }
  
  const [value, setValue] = useState(0);
  const handleChangeTab = (event, newValue) => {
    setValue(newValue);
  };

  function handleChangeCategory(event, value) {
    if (Array.isArray(value)) {
      const isGroupe = value.some(item => item.type === "groupe");
      setTypeintervenant(isGroupe ? "groupe" : "uni");
    } else {
      setTypeintervenant(value?.type === "groupe" ? "groupe" : "uni");
    }
    setForm({ ...form, category_mission_id: value });
  }
  
  function handleCancel() {
    navigate("/mission/planning_mission");
  }
  
  return (
    <MainContainer {...headerDataMission}>
      <Backdrop className={classes.backdrop} open={openBackdrop}>
        <CircularProgress color="inherit" />
        <Typography variant="h6" style={{ marginLeft: 16 }}>
          Chargement en cours...
        </Typography>
      </Backdrop>
      
      <Message
        open={open}
        color={color}
        messageInfo={messageInfo}
        handleClose={handleCloseMessage}
      />
      <Spacer y={2} />
      <Paper className={classes.root} style={{width:"100%"}}>
        <AntTabs
          value={value}
          onChange={handleChangeTab}
          indicatorColor="primary"
          textColor="primary" 
        >
          <AntTab label="Planification" />
        </AntTabs>
        <TabPanel value={value} index={0} >
          <Grid container spacing={3} className={classes.paper}>
              <Grid item xs={12}>
                {distinctpage === "planning" && raison!==null &&
                 
                    <Alert severity="error">Observation : {raison}</Alert>           

                }
              </Grid>
    
            <Grid item xs={12}>
              <Alert severity="info">Si une catégorie est une catégorie groupée, cela signifie que plusieurs personnes participent à la mission. 
              Il y a à la fois un intervenant principal et des participants.</Alert>           
            </Grid>
            <Grid item xs={12}>
              <fieldset>
                <legend>Objet de la mission</legend>
                <br />
                <Grid container spacing={3}>
                  <Grid item xs={2}>
                    <label className={classes.labelPosition}>Catégorie</label>
                  </Grid>
                  <Grid item xs={10}>
                    <Autocomplete
                      multiple
                      onChange={handleChangeCategory}
                      options={category || []}
                      getOptionLabel={(option) => {
                        let label = option?.name || "";
                        if (option?.type === "groupe") {
                            label += ` (catégorie groupée)`;
                        }
                        return label;
                      }}
                      value={Array.isArray(form.category_mission_id) ? form.category_mission_id : []}
                      isOptionEqualToValue={isOptionEqualToValueCategory}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          fullWidth
                          id="outlined-basic"
                          label="Catégorie"
                          size="small"
                          variant="outlined"
                          InputProps={{ ...params.InputProps, type: "search" }}
                        />
                      )}
                    /> 
                    {isValidCategory_mission_id && (
                      <Alert severity="error">Veuillez remplir ce champ</Alert>
                    )}
                  </Grid>
                  <Grid item xs={2}>
                    <label className={classes.labelPosition}>Objet de la mission</label>
                  </Grid>
                  <Grid item xs={10}>
                    <TextField
                      fullWidth
                      multiline rows={5}
                      id="outlined-basic"
                      size="small"
                      label="Objet de la mission"
                      variant="outlined"
                      value={form.mission_title}
                      name="mission_title"
                      onChange={handleChange}
                    />
                    {isValidMission_title && (
                      <Alert severity="error">Veuillez remplir ce champ</Alert>
                    )}
                  </Grid>
                </Grid>
                <br />
              </fieldset>
            </Grid>
            <Grid item xs={12}>
              {sections.map((section, index) => (
                <fieldset key={index} style={{ marginBottom: "20px" }}>
                  <legend>Date de planification et lieu de destination de la mission {index + 1}</legend>
                  <br />
                  <Grid container spacing={3}>
                    <Grid item xs={3}>
                      <label>Region de destination *</label>
                    </Grid>
                    <Grid item xs={9}>
                      <Autocomplete
                        onChange={(event, newValue) => handleSectionChange(index, "region", newValue)}
                        options={region}
                        getOptionLabel={(option) => option?.nom_region || ""}
                        value={section.region}
                        isOptionEqualToValue={isOptionEqualToValueRegion}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            fullWidth
                            label="Région"
                            size="small"
                            variant="outlined"
                            InputProps={{ ...params.InputProps, type: "search" }}
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <label>District de destination * </label>
                    </Grid>
                    <Grid item xs={9}>
                      <Autocomplete
                        multiple
                        onChange={(event, newValue) => handleSectionChange(index, "district", newValue)}
                        options={district}
                        value={section.district}
                        getOptionLabel={(option) => option?.nom_district || ""}
                        isOptionEqualToValue={isOptionEqualToValueDistrict}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            fullWidth
                            label="Districts"
                            size="small"
                            variant="outlined"
                            InputProps={{ ...params.InputProps, type: "search" }}
                          />
                        )}
                        renderTags={(value, getTagProps) =>
                          value.map((option, idx) => (
                            <Chip
                              {...getTagProps({ index: idx })}
                              key={option?.id_district || idx}
                              label={option?.nom_district || ""}
                              size="small"
                            />
                          ))
                        }
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <label>Commune de destination</label>
                    </Grid>
                    <Grid item xs={9}>
                      <Autocomplete
                        multiple
                        onChange={(event, newValue) => handleSectionChange(index, "commune", newValue)}
                        options={commune}
                        value={section.commune}
                        getOptionLabel={(option) => option?.nom_commune || ""}
                        isOptionEqualToValue={isOptionEqualToValueCommune}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            fullWidth
                            label="Commune"
                            size="small"
                            variant="outlined"
                            InputProps={{ ...params.InputProps, type: "search" }}
                          />
                        )}
                        renderTags={(value, getTagProps) =>
                          value.map((option, idx) => (
                            <Chip
                              {...getTagProps({ index: idx })}
                              key={option?.id_commune || idx}
                              label={option?.nom_commune || ""}
                              size="small"
                            />
                          ))
                        }
                      />
                    </Grid>

                    <Grid item xs={3}>
                      <label>Direction de destination *</label>
                    </Grid>
                    <Grid item xs={9}>
                      <Autocomplete
                        value={section.direction_dest || null}
                        onChange={(_, newValue) => handleSectionChange(index, "direction_dest", newValue)}
                        options={direction}
                        getOptionLabel={(option) => option?.name + " (" + option?.code + ")" || ""}
                        isOptionEqualToValue={isOptionEqualToValueDirection}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            fullWidth
                            label="Direction de destination"
                            size="small"
                            variant="outlined"
                          />
                        )}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <Alert severity="info">Assurez-vous de prendre en compte le temps de trajet lors de l'ajout des dates.</Alert>
                    </Grid>

                    <Grid item xs={3}>
                      <label>Date de départ *</label>
                    </Grid>
                    <Grid item xs={9}>
                      <TextField
                        fullWidth
                        size="small"
                        variant="outlined"
                        type="date"
                        value={section.date_depart}
                        onChange={(e) => handleSectionChange(index, "date_depart", e.target.value)}
                      />
                    </Grid>

                    <Grid item xs={3}>
                      <label>Date de retour *</label>
                    </Grid>
                    <Grid item xs={9}>
                      <TextField
                        fullWidth
                        size="small"
                        variant="outlined"
                        type="date"
                        value={section.date_retour}
                        onChange={(e) => handleSectionChange(index, "date_retour", e.target.value)}
                      />
                    </Grid>

                    {typeintervenants === "uni" && (
                      <>
                        <Grid item xs={3}>
                          <label>Direction des missionaires *</label>
                        </Grid>
                        <Grid item xs={9}>
                          <Autocomplete
                            multiple
                            value={section.directions}
                            onChange={(_, newValue) => handleSectionChange(index, "directions", newValue)}
                            options={direction || []}
                            getOptionLabel={(option) => option?.name + " (" + option?.code + ")" || ""}
                            isOptionEqualToValue={isOptionEqualToValueDirection}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                fullWidth
                                label="Direction"
                                size="small"
                                variant="outlined"
                              />
                            )}
                          />
                        </Grid>

                        <Grid item xs={3}>
                          <label>Service des missionaires * </label>
                        </Grid>
                        <Grid item xs={9}>
                          <Autocomplete
                            multiple
                            value={section.services}
                            onChange={(_, newValue) => handleSectionChange(index, "services", newValue)}
                            options={service || []}
                            getOptionLabel={(option) => option?.name + " (" + option?.code + ")" || ""}
                            isOptionEqualToValue={isOptionEqualToValueService}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                fullWidth
                                label="Service"
                                size="small"
                                variant="outlined"
                              />
                            )}
                          />
                        </Grid>

                        <Grid item xs={3}>
                          <label>Missionnaires *</label>
                        </Grid>
                        <Grid item xs={9}>
                          <Autocomplete
                            multiple
                            value={section.missionnaires}
                            onChange={(_, newValue) => handleSectionChange(index, "missionnaires", newValue)}
                            options={intervenant || []}
                            getOptionLabel={(option) => option?.first_name + " " + option?.last_name || ""}
                            isOptionEqualToValue={isOptionEqualToValueIntervenant}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                fullWidth
                                label="Missionnaires"
                                size="small"
                                variant="outlined"
                              />
                            )}
                          />
                        </Grid>
                      </>
                    )}
                    {typeintervenants === "uni" && index !== 0 && (
                      <>
                        <Grid item xs={9}>
                        </Grid>
                        <Grid item xs={3}>
                          <Button
                            variant="outlined"
                            color="secondary"
                            onClick={() => removeSection(index)}
                            style={{ marginTop: "10px", color: "red", borderColor: "red" }}
                          >
                            Supprimer section
                          </Button>
                        </Grid> 
                      </>
                    )}
                  </Grid>
                </fieldset>
              ))}
              {typeintervenants === "uni" && (
                <Button variant="contained" color="primary" onClick={addSection} style={{ marginTop: "20px" }}>
                  Ajouter une nouvelle destination 
                </Button>
              )}
            </Grid>
            {typeintervenants === "groupe" &&
              <>
                <Grid item xs={12}>
                  <fieldset>
                    <legend>Intervenants</legend><br/>
                    <Grid container spacing={3}>
                      <Grid item xs={2}>
                        <label className={classes.labelPosition}>Direction</label>
                      </Grid>
                      <Grid item xs={10}>
                        <Autocomplete
                          multiple
                          onChange={handleChangeDirection}
                          options={direction || []}
                          getOptionLabel={(option) => option?.name + ' (' + option?.code + ')' || ""}
                          isOptionEqualToValue={isOptionEqualToValueDirection}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              fullWidth
                              label="Direction"
                              size="small"
                              variant="outlined"
                              InputProps={{ ...params.InputProps, type: "search" }}
                            />
                          )}
                        />
                      </Grid>
                      <Grid item xs={2}>
                        <label>Service</label>
                      </Grid>
                      <Grid item xs={10}>
                        <Autocomplete
                          multiple
                          onChange={handleChangeService}
                          options={service || []}
                          getOptionLabel={(option) => option?.name + ' (' + option?.code + ')' || ""}
                          isOptionEqualToValue={isOptionEqualToValueService}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              fullWidth
                              label="Service"
                              size="small"
                              variant="outlined"
                              InputProps={{ ...params.InputProps, type: "search" }}
                            />
                          )}
                        />
                      </Grid>
                      <Grid item xs={2}>
                        <label className={classes.labelPosition}>Intervenants</label>
                      </Grid>
                      <Grid item xs={10}>
                        <Autocomplete
                          multiple
                          id="tags-outlined"
                          options={intervenant || []}
                          getOptionLabel={(option) => option?.first_name + ' ' + option?.last_name || ""}
                          filterSelectedOptions
                          onChange={handleChangeIntervenants}
                          value={form.user_id}
                          isOptionEqualToValue={isOptionEqualToValueIntervenant}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              fullWidth
                              id="outlined-basic"
                              size="small"
                              label="Intervenants"
                              variant="outlined"
                              placeholder="Intervenants"
                            />
                          )} 
                        />
                      </Grid>
                    </Grid><br />
                  </fieldset>
                </Grid>
                <Grid item xs={12}>
                  <fieldset>
                    <legend>Autre(s) intervenant(s)</legend><br />
                    <Grid container spacing={3}>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          id="outlined-basic"
                          size="small"
                          label="Autres intervenants"
                          variant="outlined"
                          value={intervenants}
                          name="intervenants"
                          onChange={handleChangeintervenantsautre}
                          onKeyDown={handleKeyDownintervenantsautre}
                          placeholder=" Appuyer sur la touche Entrée avant d'ajouter un nouveau intervenant"
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Stack direction="row" spacing={1} flexWrap="wrap">
                          {tagsintervenant.map((tag, index) => (
                            <Chip
                              key={index}
                              label={tag}
                              onDelete={() => handleDeleteintervenant(tag)}
                            />
                          ))}
                        </Stack>
                      </Grid>
                    </Grid>
                    <br />
                  </fieldset>
                </Grid>
                <Grid item xs={12}>
                  <fieldset>
                    <legend>Participants</legend><br/>
                    <Grid container spacing={3}>
                      <Grid item xs={12}>
                        <div style={noteStyle}>
                          <p>Pour choisir les participants, veuillez sélectionner l'une des options suivantes :</p>
                          <ul>
                            <li style={{textAlign:'left'}}>Direction</li>
                            <li style={{textAlign:'left'}}>Direction et Service</li>
                            <li style={{textAlign:'left'}}>Direction et Fonction</li>
                            <li style={{textAlign:'left'}}>Fonction</li>
                          </ul>
                        </div>
                      </Grid>
                      <Grid item xs={3}>
                        <label className={classes.labelPosition}>Direction</label>
                      </Grid>
                      <Grid item xs={9}>
                        <Autocomplete
                          multiple
                          onChange={handleChangepDirection}
                          options={pdirection || []}
                          getOptionLabel={(option) => option?.name + ' (' + option?.code + ')' || ""}
                          isOptionEqualToValue={isOptionEqualToValueDirection}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              fullWidth
                              label="Direction"
                              size="small"
                              variant="outlined"
                              InputProps={{ ...params.InputProps, type: "search" }}
                            />
                          )}
                        />
                      </Grid>
                      <Grid item xs={3}>
                        <label className={classes.labelPosition}>Service</label>
                      </Grid>
                      <Grid item xs={9}>
                        <Autocomplete
                          multiple
                          onChange={handleChangepService}
                          options={pservice || []}
                          getOptionLabel={(option) => option?.name + ' (' + option?.code + ')' || ""}
                          isOptionEqualToValue={isOptionEqualToValueService}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              fullWidth
                              label="Service"
                              size="small"
                              variant="outlined"
                              InputProps={{ ...params.InputProps, type: "search" }}
                            />
                          )}
                        />
                      </Grid>
                      <Grid item xs={3}>
                        <label className={classes.labelPosition}>Fonction</label>
                      </Grid>
                      <Grid item xs={9}>
                        <Autocomplete
                          multiple
                          onChange={handleChangepfonction}
                          options={pfonction || []}
                          getOptionLabel={(option) => option?.name + ' (' + option?.code + ')' || ""}
                          isOptionEqualToValue={isOptionEqualToValueFonction}
                          filterSelectedOptions
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              fullWidth
                              label="Fonction"
                              size="small"
                              variant="outlined"
                              InputProps={{ ...params.InputProps, type: "search" }}
                            />
                          )}
                        />
                      </Grid>
                      <Grid item xs={3}>
                        <label className={classes.labelPosition}>Participants</label>
                      </Grid>
                      <Grid item xs={9}>
                        <Autocomplete
                          multiple
                          id="tags-outlined"
                          options={[selectAllOption, ...participant]}
                          disableCloseOnSelect
                          getOptionLabel={(option) => `${option?.first_name || ""} ${option?.last_name || ""}`}
                          value={form.list_user || []}
                          isOptionEqualToValue={isOptionEqualToValueParticipant}
                          renderTags={(values) =>
                            values.map((value) => (
                              <Chip
                                key={value.user_id}
                                label={`${value.first_name} ${value.last_name}`}
                              />
                            ))
                          }
                          renderOption={(option, { selected }) => (
                            <React.Fragment>
                              <Checkbox
                                icon={icon}
                                checkedIcon={checkedIcon}
                                style={{ marginRight: 8 }}
                                checked={selected}
                              />
                              {`${option.first_name || ""} ${option.last_name || ""}`}
                            </React.Fragment>
                          )}
                          style={{ width: '100%' }} 
                          onChange={handleChangelistuser}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              label="Participants"
                              placeholder="Favorites"
                              fullWidth  
                            />
                          )}
                        />
                      </Grid>
                      <Grid item xs={3}>
                        <label className={classes.labelPosition}>Groupé l'affichage par</label>
                      </Grid>
                      <Grid item xs={9}>
                        <Autocomplete
                          multiple
                          id="tags-outlined-group"
                          options={options || []}
                          getOptionLabel={(option) => option?.label || ""}
                          filterSelectedOptions
                          onChange={handleOptionChange}
                          value={selectedOptions}
                          style={{ width: '100%' }} 
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              fullWidth  
                              id="outlined-basic-group"
                              size="small"
                              label="Groupé l'affichage par"
                              variant="outlined"
                              placeholder=""
                            />
                          )}
                        />
                      </Grid>
                    </Grid>
                  </fieldset>
                </Grid>
              </>
            }
           
            <Grid item xs={12}>
              <fieldset>
                <legend>Rapport de mission</legend>
                <br />
                <Alert severity="info">Veuillez cocher plusieurs rapports de mission si votre mission nécessite plus d'un rapport</Alert>
                <br />
                <FormControl>
                  <RadioGroup
                    value={missionReportType}
                    onChange={(e) => setMissionReportType(e.target.value)}
                  >
                    <FormControlLabel
                      value="mission"
                      control={<Radio />}
                      label="Un seul rapport de mission"
                    />
                    <FormControlLabel
                      value="destination"
                      control={<Radio />}
                      label="Plusieurs rapports de mission"
                    />
                  </RadioGroup>
                </FormControl>
              </fieldset>
            </Grid>
            <Grid item xs={12}>
              <fieldset>
                <legend>Autre(s) participant(s) possible</legend><br />
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      id="outlined-basic"
                      size="small"
                      label="Autres participants"
                      variant="outlined"
                      value={partnership}
                      name="partnership"
                      onChange={handleChangepartenachip}
                      onKeyDown={handleKeyDown}
                      placeholder=" Appuyer sur la touche Entrée avant d'ajouter un nouveau participant"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Stack direction="row" spacing={1} flexWrap="wrap">
                      {tags.map((tag, index) => (
                        <Chip
                          key={index}
                          label={tag}
                          onDelete={() => handleDelete(tag)}
                        />
                      ))}
                    </Stack>
                  </Grid>
                </Grid>
                <br />
              </fieldset>
            </Grid>
            <Grid item xs={12}>
              <fieldset>
                <legend>Moyen de transport</legend>
                <br />
                <Grid container spacing={3}>
                  <Grid item xs={2}>
                    <label className={classes.labelPosition}> Moyen de transport</label>
                  </Grid>
                  <Grid item xs={10}>
                    <FormControl fullWidth variant="outlined" size="small">
                      <Autocomplete
                        id="transport-autocomplete"
                        multiple 
                        options={transport || []}
                        getOptionLabel={(option) => option?.designation || ""}
                        value={transport.filter((ts) => form.transport_type?.includes(ts.transport_id))} 
                        isOptionEqualToValue={isOptionEqualToValueTransport}
                        onChange={(event, newValue) => {
                          handleChange({
                            target: {
                              name: "transport_type",
                              value: newValue.map((ts) => ts.transport_id), 
                            },
                          });
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Moyen de transport"
                            variant="outlined"
                            fullWidth
                          />
                        )}
                        renderTags={(value, getTagProps) =>
                          value.map((option, index) => (
                            <Chip
                              key={option.transport_id}
                              label={option.designation}
                              {...getTagProps({ index })}
                            />
                          ))
                        }
                      />
                    </FormControl>
                  </Grid>
                  {isValidTransport_type && (
                    <Alert severity="error">Veuillez remplir ce champ</Alert>
                  )}
                </Grid>
                <br />
              </fieldset>
            </Grid>
            <Grid item xs={12}>
              {distinctpage === "add" &&
                <LoadingButton
                  type="button"
                  className={classes.labelPosition1}
                  variant="contained"
                  color="primary"
                  onClick={handleClick}
                  loading={openBackdrop}
                  loadingPosition="start"
                  style={{ fontWeight: 600, marginRight: 8 }}
                >
                  ENREGISTRER
                </LoadingButton>
              }
              {distinctpage === "validate" &&
                <LoadingButton
                  type="button"
                  className={classes.labelPosition1}
                  variant="contained"
                  color="primary"
                  onClick={handlesuivant}
                  loading={openBackdrop}
                  loadingPosition="start"
                  style={{ fontWeight: 600, marginRight: 8 }}
                >
                  SUIVANT
                </LoadingButton>
              }
              {distinctpage === "planning" &&
                <>
                  <Button
                    type="button"
                    className={classes.labelPosition1}
                    variant="contained"
                    color="primary"
                    onClick={handleclickplanning}
                    style={{ fontWeight: 600 }}
                  >
                    Enregistrer puis envoyer
                  </Button>

                  <Button
                    type="button"
                    className={classes.labelPosition1}
                    variant="contained"
                    color="primary"
                    onClick={handleClick}
                    style={{ fontWeight: 600 , marginRight: 12}}
                  >
                    Enregistrer
                  </Button>
                </>
              }
              <Button
                type="button"
                variant="contained"
                color="grey"
                onClick={handleCancel}
                style={{ fontWeight: 600 }}
              >
                ANNULER
              </Button>
            </Grid>
          </Grid>
        </TabPanel>
        <TabPanel value={value} index={1}>
          {MISSION_PLANNING_TEMP !== null && <PlanningMissionDetailsAdd />}
          {MISSION_PLANNING_TEMP === null && (
            <Alert severity="warning">
              Veuillez remplir les informations nécessaires dans la
              Planification de la Mission svp !
            </Alert>
          )}
        </TabPanel>
        <div>
          <Dialog
            open={affichelist}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleClosealert}
            aria-describedby="alert-dialog-slide-description"
            maxWidth="md"
            fullWidth
          >
            <DialogTitle style={{ padding: 0 }}>
              <div style={noteStyleerreur}>
                <p style={{ margin: '0' }}>Planning existant</p>          
              </div>
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell>Réference de la mission</TableCell>
                        <TableCell align="right">Objet de mission</TableCell>
                        <TableCell align="right">Date de départ</TableCell>
                        <TableCell align="right">Date de retour</TableCell>
                        <TableCell align="right">Status Planning</TableCell>
                        <TableCell align="right">Status Réel</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {planninglist.map((row) => (
                        <TableRow
                          key={row.mission_planning_id}
                          sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                          <TableCell component="th" scope="row">
                            {row.reference}
                          </TableCell>
                          <TableCell align="right">{row.mission_title}</TableCell>
                          <TableCell align="right">{row.date_debut}</TableCell>
                          <TableCell align="right">{row.date_fin}</TableCell>
                          <TableCell align="right">{row.stateplanning}</TableCell>
                          <TableCell align="right">{row.state}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
                <p>Vous avez déjà une mission planifiée autour de ces dates. Veuillez ajuster le nouveau planning ou utiliser le planning existant.</p>      
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button variant="outlined" color="secondary" onClick={handleClosealert}>
                D'accord, compris
              </Button>
            </DialogActions>
          </Dialog>
        </div>
        <div>
          {/* Dialogue pour la liste des missions sans rapport */}
          <Dialog
            open={affichelistwithoutrapport}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleClosealertrapport}
            aria-describedby="alert-dialog-slide-description"
            maxWidth="md"
            fullWidth
          >
            <DialogTitle style={{ padding: 0 }}>
              <div style={noteStyleerreur}>
                <p style={{ margin: '0' }}>Rapport de mission non effectué</p>          
              </div>
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell>Réference de la mission</TableCell>
                        <TableCell align="right">Objet de mission</TableCell>
                        <TableCell align="right">Date de départ</TableCell>
                        <TableCell align="right">Date de retour</TableCell>
                        <TableCell align="right">Missionaire(s)</TableCell>
                        <TableCell align="right">Status Réel</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {listnotRapport.map((row) => (
                        <TableRow
                          key={row.mission_planning_id}
                          sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                          <TableCell component="th" scope="row">
                            {row.reference}
                          </TableCell>
                          <TableCell align="right">{row.mission_title}</TableCell>
                          <TableCell align="right">{row.date_debut}</TableCell>
                          <TableCell align="right">{row.date_fin}</TableCell>
                          <TableCell align="right">{row.missionary}</TableCell>
                          <TableCell align="right">{row.state}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
                <div style={noteStyleWarning}>
                  <p>Veuillez ajouter les rapports de mission avant d'envoyer une nouvelle mission en validation.</p>      
                  <p>Si la mission n'a pas été effectuée, vous pouvez demander une dérogation à votre supérieur hiérarchique.</p>
                </div>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button variant="outlined" color="secondary" onClick={handleClosealertrapport}>
                Fermer
              </Button>
              <Button 
                variant="contained" 
                color="secondary"
                onClick={handleOpenDerogation}
                style={{ backgroundColor: "#ed6c02", color: "#fff" }}
              >
                Demander une dérogation
              </Button>
            </DialogActions>
          </Dialog>

          {/* Dialogue pour la demande de dérogation */}
          <Dialog
            open={showDerogationDialog}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleCloseDerogation}
            maxWidth="md"
            fullWidth
          >
            <DialogTitle style={{ padding: 0 }}>
              <div style={noteStyleWarning}>
                <p style={{ margin: '0' }}>Demande de dérogation</p>          
              </div>
            </DialogTitle>
            <DialogContent>
              <DialogContentText>
                <p>
                  Vous vous apprêtez à demander une dérogation pour les missions suivantes qui n'ont pas de rapport :
                </p>
                <ul>
                  {listnotRapport.map((mission, index) => (
                    <li key={index}>
                      <strong>{mission.reference}</strong> - {mission.mission_title}
                    </li>
                  ))}
                </ul>
                <p>
                  Veuillez fournir une raison valable pour justifier cette dérogation.
                  Un email sera envoyé à votre supérieur hiérarchique :
                  si vous êtes à la Direction Générale, le message sera envoyé à la DG et à la DP ;
                  sinon, il sera envoyé à la DR ou au CA.
                </p>
                <TextField
                  fullWidth
                  multiline
                  rows={4}
                  variant="outlined"
                  label="Raison de la dérogation"
                  placeholder="Expliquez pourquoi ces missions n'ont pas de rapport et pourquoi vous souhaitez continuer..."
                  value={derogationReason}
                  onChange={(e) => setDerogationReason(e.target.value)}
                  margin="normal"
                />
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseDerogation} color="secondary">
                Annuler
              </Button>
              <LoadingButton
                onClick={submitDerogation}
                color="warning"
                variant="contained"
                loading={isSubmittingDerogation}
                loadingPosition="start"
              >
                Soumettre la demande
              </LoadingButton>
            </DialogActions>
          </Dialog>
        </div>
      </Paper>
    </MainContainer>
  );
}

export default PlanningMissionAdd;